// extracted by mini-css-extract-plugin
export default {"NewsList":"NewsList_NewsList__AjwYi","LoadMore":"NewsList_LoadMore__iEGby"};